<alaris-card>

    <h4 class="title">{{'manual_dipping.task.title' | translate}}&nbsp;DD-{{mdTaskID}}</h4>

    <alaris-tabs class="tabs"
        [underline]="true">

        <alaris-tab [label]="'manual_dipping.successful' | translate"
            tabId="first">
            <app-manual-dipping-results-table></app-manual-dipping-results-table>
        </alaris-tab>

        <alaris-tab [label]="'manual_dipping.errors' | translate"
            tabId="second">
            <app-manual-dipping-errors-table></app-manual-dipping-errors-table>
        </alaris-tab>
    </alaris-tabs>
</alaris-card>